import { apiSuccess, apiList } from '@services/apiSchemas';
import {
  ProductSerialNumberDetailSchema,
  ProductSerialNumberRecordSchema,
} from '@services/shared/productSerialNumberSchemas';

import operatorApiFetch from './apiService';

// Schema 與 type 全部來自 @services/shared/productSerialNumberSchemas
// operator base_scope 強制 status='in_stock' + current_warehouse + accessible merchants
// 屬於 server-side 隔離，不影響 response shape，故與 admin 共用同一份 schema。
export type {
  ProductSerialNumberDetail,
  ProductSerialNumberInventory,
  ProductSerialNumberRecord,
  ProductSerialNumberStatus,
  ProductSerialNumberTimelineEvent,
  ProductSerialNumberTimelineEventType,
} from '@services/shared/productSerialNumberSchemas';

const productSerialNumberService = {
  // 列表（PSN 識別中心查詢）
  // operator 端 BE 強制 status='in_stock'，client 即使送 status 也會被 ignore（仍可送，無 side effect）
  getRecords: async (params: Record<string, unknown> = {}) => {
    const res = await operatorApiFetch('product_serial_numbers/get_records', {
      method: 'POST',
      body: params,
    });
    return apiList(ProductSerialNumberRecordSchema).parse(await res.json());
  },

  // 詳細（含 timeline）
  getById: async (id: string) => {
    const res = await operatorApiFetch(`product_serial_numbers/${id}`, {
      method: 'GET',
    });
    return apiSuccess(ProductSerialNumberDetailSchema).parse(await res.json());
  },
};

export default productSerialNumberService;
